import ReactFinalForm from 'components/form/ReactFinalForm';
import { IContractEquipment } from 'interfaces';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import toast from 'features/toast';

interface UpdateContractEquipmentDialogFormParams {
  open?: boolean;
  contractEquipment: IContractEquipment;
  onSubmit: (id: any, values: any) => void;
}

function UpdateContractEquipmentDialog(params: UpdateContractEquipmentDialogFormParams) {
  const { t } = useTranslation();
  const { contractEquipment, onSubmit } = params;
  const translationPrefix = 'pages.contract-equipment.edit';

  const [openDialog, setOpenDialog] = useState(false);

  const openContractEquipmentEditDialog = () => setOpenDialog(true);
  const closeContractEquipmentEditDialog = () => setOpenDialog(false);

  const onSubmitContractEquipment = async (values: any) => {
    // Only one of yearly_lease_amount or purchase_amount can have a value
    if (
      (values.yearly_lease_amount && values.purchase_amount) ||
      (!values.yearly_lease_amount && !values.purchase_amount)
    ) {
      toast.warning(
        t('pages.contract-equipment.edit.only_one_allowed', {
          field1: t('entities.contract-equipment.yearly_lease_amount'),
          field2: t('entities.contract-equipment.purchase_amount')
        })
      );
      // setOpenDialog(false);
      return;
    }
    onSubmit(contractEquipment.id, values);
    setOpenDialog(false);
  };

  return (
    <div>
      <GridActionsCellItem
        key={970}
        label={t('actions.edit')}
        icon={<EditIcon />}
        onClick={openContractEquipmentEditDialog}
      />
      <Dialog
        open={openDialog}
        onClose={() => params.onSubmit(contractEquipment.id, null)}
        fullWidth
        maxWidth="md">
        <DialogTitle id="alert-dialog-title">
          {t(`${translationPrefix}.title`, {
            code: contractEquipment.equipment
          })}
        </DialogTitle>
        <DialogContent>
          <ReactFinalForm
            onSubmit={onSubmitContractEquipment}
            formId="updateContracEquipment"
            hideControls>
            <div className="flex flex-wrap">
              <div className="w-1/3 p-4">
                <IdentityField
                  name="yearly_lease_amount"
                  component={TextFieldAdapter}
                  label={t('entities.contract-equipment.yearly_lease_amount')}
                  type="number"
                  // initValues={parseInt(contractEquipment.yearly_lease_amount as any, 10) || 0}
                  defaultValue={parseInt(contractEquipment.yearly_lease_amount as any) || null}
                />
              </div>
              <div className="w-1/3 p-4">
                <IdentityField
                  name="yearly_maintenance_amount"
                  component={TextFieldAdapter}
                  label={t('entities.contract-equipment.yearly_maintenance_amount')}
                  type="number"
                  defaultValue={parseInt(contractEquipment.yearly_lease_amount as any) || null}
                  //initValues={parseInt(contractEquipment.yearly_lease_amount as any, 10) || 0}
                />
              </div>
              <div className="w-1/3 p-4">
                <IdentityField
                  name="purchase_amount"
                  component={TextFieldAdapter}
                  label={t('entities.contract-equipment.purchase_amount')}
                  type="number"
                  defaultValue={parseInt(contractEquipment.purchase_amount as any) || null}
                  // initValues={parseInt(contractEquipment.purchase_amount as any, 10) || 0}
                />
              </div>
            </div>
          </ReactFinalForm>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeContractEquipmentEditDialog} color="error">
            {t('actions.cancel')}
          </Button>
          <Button type="submit" form="updateContracEquipment" color="primary">
            {t('actions.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default UpdateContractEquipmentDialog;
